module.exports = __webpack_public_path__ + "img/LOGO_UBRUlib.f9bb7aae.png";